/* -------------------------------------
 API Config Service
 - Sets urls for correct environment.
-------------------------------------- */

// Angular services
import { Injectable } from '@angular/core';

// Our services & pages
import { AppInstance } from '../shared/enums/app-instance.enum';

export class ApiConfigBase {
    constructor(public readonly apiInstance: AppInstance) { }

    public getInstanceName(): string {
        let value = this.apiInstance;
        return AppInstance[value];
    }
}


//local dev version using ionic serve
@Injectable()
export class ApiConfig extends ApiConfigBase {
    public readonly apiBaseForum:string;
    public readonly authTokenPrefixForum:string;
    public readonly OrganisationGuid: string;
    public readonly BadgeContainer: string;
   
    constructor(){
        // super(AppInstance.Dev);
        // this.apiBaseForum = 'http://localhost:51023';
        // this.authTokenPrefixForum = 'BADGE-TOKEN';
        // this.BadgeContainer = "badges-qa";


        //HAVE YOU CHANGED THE LINK IN badges.html
        super(AppInstance.Test);
        this.apiBaseForum = 'https://enetcloud-saas-enetbadges-c19-api-staging.azurewebsites.net';
        this.authTokenPrefixForum = 'BADGE-TOKEN';
        this.BadgeContainer = "badges-dev";

        // super(AppInstance.Live);
        // this.apiBaseForum = 'https://api.enetbadges.com/';
        // this.authTokenPrefixForum = 'BADGE-TOKEN';
        // this.BadgeContainer = "badges-live";

    }
}



// WEBPACK FOOTER //
// ./src/shared/api-config.service.ts